export enum Resources {
  Geographies = 'geographies',
  WayFilters = 'wayFilters',
  WayOverrides = 'wayOverrides',
  TurnRules = 'turnRules',
}

export enum NotFoundResource {
  Geography = 'geography',
  WayFilter = 'wayFilter',
  WayOverride = 'wayOverride',
  TurnRule = 'turnRule',
}
